import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import RenderingTile from 'components/molecules/RenderingTile';
import CallOutValueWithChange from 'components/molecules/CallOutValueWithChange';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import VideoViewsExpandContainer from 'containers/dashboards/social/VideoViewsExpandContainer';
import { LAYERTHREE } from 'constants/layers';

class VideoViewsModule extends Component {
    render() {
        const { layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social`;
        const { actions, campaigns, callouts } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', null);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutsData = hasCalloutData ? callouts.data : {};

        return (
            <ObjectiveVisibilityContainer objective={'VIDEO_VIEWS'}
                actions={actions} campaigns={campaigns} layer={layer} expandContainer={VideoViewsExpandContainer} >
                {/* Call Outs */}
                <Row>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-video-views-callouts-started-plays`}
                                title="Video Plays"
                                type="started_plays"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_started_plays,
                                    change: Math.round(
                                        calloutsData.started_plays_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' show={hasCalloutData} />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-video-views-callouts-completed-plays`}
                                title="Completed Plays"
                                type="completed_plays"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_completed_plays,
                                    change: Math.round(
                                        calloutsData.completed_plays_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' show={hasCalloutData} />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-video-views-callouts-completion-rate`}
                                title="Completion Rate"
                                type="completion_rate"
                                data={{
                                    value: calloutsData.current_completion_rate,
                                    change: Math.round(calloutsData.completion_rate_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                format='0.00%'
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' show={hasCalloutData} />
                        )}
                    </Col>
                </Row>

            </ObjectiveVisibilityContainer>
        );
    }
}

VideoViewsModule.propTypes = {
    module: PropTypes.shape({
        actions: PropTypes.object,
        callouts: PropTypes.object,
        campaigns: PropTypes.object,
        timeData: PropTypes.object
    }).isRequired
};

export default VideoViewsModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/VideoViewsModule.js